const peopleLookEditRights = {
  view_only: 'view_only',
  create_edit_report: 'create_edit_report',
  create_edit_report_template: 'create_edit_report_template',
};

export default peopleLookEditRights;
